export default __webpack_public_path__ + "static/media/user_purple.9c7ed2c0.svg";